import Stack from '@mui/material/Stack';
import InfoItem from './InfoItem';

export default function ProfileCard({ data, keyValue }) {
  return (
    <Stack spacing={1.5}>
      {keyValue.map(({ label, value }, i) => (
        <InfoItem label={label} value={data?.[value]} key={i} />
      ))}
    </Stack>
  );
}
